export default {
  computed: {
    isPageInIframe () {
      return this.$route.query?.iframe ?? false
    }
  }
}
